import BaseService from '@src/services/BaseService'

class WorkScheduleAssumeService extends BaseService {
    constructor() {
        super('work-schedules/assume')
    }

    /**
     * Busca usuários inativos/afastados cujos roteiros podem ser assumidos
     * @param {number} sourceUserId - ID do usuário da página que está assumindo (destino)
     * @param {Object} filters - Filtros opcionais para busca
     * @param {string} filters.search - Termo de busca por nome do usuário
     * @param {number} filters.page - Página atual (padrão: 1)
     * @param {number} filters.per_page - Itens por página (padrão: 10)
     * @returns {Promise} Resposta da API com lista de usuários disponíveis
     */
    getAvailableUsers(sourceUserId, filters = {}) {
        const params = {
            source_user_id: sourceUserId,
            ...filters,
        }

        return this.axios.get(`${this.getUrl()}/available-users`, { params })
    }

    /**
     * Transfere roteiros de um usuário para outro
     * @param {Object} transferData - Dados da transferência
     * @param {number} transferData.from_user_id - ID do usuário origem
     * @param {number} transferData.to_user_id - ID do usuário destino
     * @returns {Promise} Resposta da API com resultado da transferência
     */
    transferSchedule(transferData) {
        return this.axios.post(`${this.getUrl()}/transfer`, {
            from_user_id: transferData.from_user_id,
            to_user_id: transferData.to_user_id,
        })
    }

    /**
     * Valida se um usuário pode assumir roteiros de outro usuário
     * @param {number} fromUserId - ID do usuário origem (inativo/afastado selecionado)
     * @param {number} toUserId - ID do usuário destino (quem assume / página)
     * @returns {Promise} Resposta da API com validação
     */
    validateTransfer(fromUserId, toUserId) {
        return this.axios.get(`${this.getUrl()}/validate`, {
            params: {
                from_user_id: fromUserId,
                to_user_id: toUserId,
            },
        })
    }

    /**
     * Normaliza resposta paginada de available-users
     * @param {Object} response - Resposta axios
     * @returns {{ users: Array, total: number }}
     */
    parseAvailableUsersResponse(response) {
        const body = response?.data ?? {}
        const users = Array.isArray(body.data) ? body.data : []
        const total = body.meta?.total ?? users.length

        return { users, total }
    }

    /**
     * Normaliza resposta de validate
     * @param {Object} response - Resposta axios
     * @returns {{ valid: boolean, message: string|null }}
     */
    parseValidateResponse(response) {
        const body = response?.data ?? {}

        return {
            valid: Boolean(body.valid),
            message: body.message ?? null,
        }
    }
}

export default new WorkScheduleAssumeService()
